import React, { useState, useContext, useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faCloud,
    faBolt,
    faCloudRain,
    faCloudShowersHeavy,
    faSnowflake,
    faSmog,
    faSun,
    faCloudSun,
    faViruses,
    faGrin,
    faSmile,
    faMeh,
    faFrown,
    faFrownOpen,
} 
from '@fortawesome/free-solid-svg-icons'
import { LanguageContext } from '../Language/LanguageContext'
import { todayWidget } from '../Network/Dashboard'
import "./Home.css"
import { RoleContext } from '../Role/RoleContext'
import dayjs from 'dayjs'

function Widget() {
    const [isLoading, setLoading] = useState(false)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const role = useContext(RoleContext)

    const [cityName, setCityName] = useState("")
    const [weatherConditionIcon, setConditionIcon] = useState(faCloudSun)
    const [currentTemp, setCurrentTemp] = useState(0)
    const [condition, setCondition] = useState("SUN")
    const [covidNewcase, setCovidNewCase] = useState(0)
    const [pm2_5color, setPm2_5color] = useState("green")
    const [pm2_5Condition, setPm2_5Condition] = useState(faGrin)
    const [pm2_5, setPm2_5] = useState(0)
    const [updatedDate, setUpdatedDate] = useState("")

    const lat = 13.75
    const long = 100.5167

    useEffect(()=>{
        setLoading(true)
        todayWidget(long, lat, langCx.code,
            (data)=>{
                let conditionId = data.weather.condition_id
                let aqi = data.air_pollution.aqi

                setCityName(data.city_name)
                setCurrentTemp(data.weather.temperature)
                setCondition(data.weather.condition)
                setCovidNewCase(data.covid_19.new_case)
                setPm2_5(data.air_pollution.pm2_5)
                
                if(conditionId >= 200 && conditionId < 300){
                    setConditionIcon(faBolt)
                }else if(conditionId >= 300 && conditionId < 500){
                    setConditionIcon(faCloudRain)
                }else if(conditionId >= 500 && conditionId < 600){
                    setConditionIcon(faCloudShowersHeavy)
                }else if(conditionId >= 600 && conditionId < 700){
                    setConditionIcon(faSnowflake)
                }else if(conditionId >= 700 && conditionId < 800){
                    setConditionIcon(faSmog)
                }else if(conditionId === 800){
                    setConditionIcon(faSun)
                }else{
                    setConditionIcon(faCloud)
                }

                switch(aqi){
                    case(1):
                        setPm2_5Condition(faGrin)
                        setPm2_5color("green")
                        break
                    case(2):
                        setPm2_5Condition(faSmile)
                        setPm2_5color("yellowgreen")
                        break
                    case(3):
                        setPm2_5Condition(faMeh)
                        setPm2_5color("gold")
                        break
                    case(4):
                        setPm2_5Condition(faFrown)
                        setPm2_5color("Crimson")
                        break
                    case(5):
                        setPm2_5Condition(faFrownOpen)
                        setPm2_5color("maroon")
                        break
                }
                setUpdatedDate(dayjs().format("dddd D MMMM YYYY - H:mm"))
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
                console.log(error.response)
            })
    },[])
    
    return(
        <div className="section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div>
                <div className="section-title">{cityName}</div>
                <div className='section-desc'>{updatedDate}</div>
                <div className="widget">
                    { role.checkPermission("_MENU_", "app.weather") ?
                    <div className="widget-item">
                        <div>
                            <FontAwesomeIcon icon={weatherConditionIcon} className="icon-widget"/>
                        </div>
                        <div className="detail">
                            <div className="temp">{parseInt(currentTemp)}&deg;C</div>
                            <div className="sub">{condition}</div>
                        </div>
                    </div>
                    : null
                    }
                    { role.checkPermission("_MENU_", "app.air_pollution") ?
                    <div className="widget-item">
                        <div>
                            <FontAwesomeIcon 
                            icon={pm2_5Condition} 
                            className="icon-widget"
                            style={{color: pm2_5color}}
                            />
                        </div>
                        <div className="detail">
                            <div className="temp">{pm2_5}</div>
                            <div className="sub">{lang.pm2_5} (μg/m<sup>3</sup>)</div>
                        </div>
                    </div>
                    : null
                    }
                    { role.checkPermission("_MENU_", "app.covid") ?
                    <div className="widget-item">
                        <div>
                            <FontAwesomeIcon icon={faViruses} className="icon-widget"/>
                        </div>
                        <div className="detail">
                            <div className="temp">+ {covidNewcase.toLocaleString()}</div>
                            <div className="sub">{lang.covid_19_new_case}</div>
                        </div>
                    </div>
                    : null
                    }
                </div>
            </div>
        </div>
    )
}

export default Widget
